<template>
    <!-- 下载中心页面--没有接口 -->
    <section class="container">
        <Header></Header>
        <div class="wrapper downloadM">
            <div class="locationM text-left">
                <Breadcrumb>
                    <img class="img" src="../assets/location.png" alt="">
                    当前位置：
                    <BreadcrumbItem to="/">首页</BreadcrumbItem>
                    <BreadcrumbItem>下载中心</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="innerM">
                <div class="title flex-row">
                    <div class="col-70 text-left">
                        下载中心
                    </div>
                    <div class="col-30 text-right downLoads pointer" @click="downfiles">
                        批量下载
                    </div>
                </div>
                <div class="ruleM">
                    <el-checkbox-group v-model="checkList">
                    <div class="rule flex-row pointer" v-for="(data, index) in dataList" :key="index">
                        <div class="col-3">
                            <el-checkbox :label="index"></el-checkbox>
                        </div>
                        <div class="col-75 text-left overflow pointer">
                            <Tooltip max-width="300" :content="data.title">
                                {{data.title}}
                            </Tooltip>
                        </div>
                        <div class="col-10 text-right date">
                            <!--07/06-->
                        </div>
                        <div class="col-10 text-center video">
                            <img src="../assets/download.png" alt="" :data-url="data.fileUrl" @click="downfile">
                        </div>
                    </div>
                    </el-checkbox-group>
                </div>
                <div class="pageM">
                    <Page :total="total" :current.sync="page" @on-change="pageClick"/>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </section>
</template>

<script>
    import Header from './components/Header'
    import Footer from './components/Footer'
    export default {
        name: "DownLoad",
        data(){
            return {
                total: 0,
                page: 1,
                dataList: [],
                checkList: []
            }
        },
        mounted(){
          this.fileList();
          this.setTab();
        },
        methods: {
            fileList(){
              var that = this;
              // that.$store.state.tab = 1;
              var modelData = {
                "page": that.page,
                "size": "10"
              };
              this.$http({
                url: that.webhost + 'attachment/list',
                method: 'POST',
                data: modelData
              }).then(({data}) => {
                if (data && data.code === 0) {
                  that.dataList = data.data.list;
                  that.total = data.data.totalCount;
                } else {
                  that.$toast.error(data.msg)
                }
              })
            },
            pageClick(){
                this.fileList();
            },
            downfile(e){
                window.open(e.currentTarget.dataset.url);
            },
            downfiles(){
              var that = this;
              for (var i = 0 ,len = that.checkList; i < len.length; i++) {
                    var item = len[i];
                    var url = that.dataList[item].fileUrl;
                    var name = that.dataList[item].title + i ;
                    window.open(url,name);
              }
            },
        },
        components: {
            Header,
            Footer
        }
    }
</script>

<style scoped>
    .wrapper{
        width: 1200px;
        min-width: 1200px;
        margin: 0 auto;
        margin-top: 20px;
        margin-bottom: 90px;
        font-family: "PingFang SC";
    }
    .title{
        text-align: left;
        font-size: 25px;
        line-height: 72px;
        color: #000;
        border-bottom: solid 2px #ccc;
    }
    .locationM{
        height: 50px;
        line-height: 50px;
    }
    .locationM .ivu-breadcrumb{
        font-size: 15px;
        color: #000;
    }
    .locationM img{
        width: 23px;
        height: 22px;
        margin-right: 5px;
        position: relative;
        top: 3px;
    }
    .ruleM{
        padding: 20px 0;
        min-height: 400px;
        width: 95%;
        margin: auto;
    }
    .rule :hover{
      color: #00b5ff;
    }
    .rule{
        font-size: 17px;
        height: 35px;
        line-height: 35px;
        position: relative;
    }
    .col-3{
        width: 3%;
    }
    .col-77{
        width: 77%;
    }
    .rule .point{
        width: 10px;
        height: 10px;
        background: #1a87cc;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
    }
    .date{
        color: #999;
    }
    .video img{
        width: 23px;
        height: 19px;
        position: relative;
        top: 1px;
    }
    .downLoads{
        font-size: 15px;
        position: relative;
        top: 15px;
    }
    .downLoads:hover{
        color: #1a87cc;
    }
</style>

<style>
    .downloadM .ivu-page-item, .ivu-page-prev, .ivu-page-next{
        border-radius: 0;
    }
    .downloadM .ivu-page-item.ivu-page-item-active{
        background: #0070bd;
    }
    .downloadM .ivu-page-item-active a{
        color: #fff;
    }
    .downloadM .el-checkbox__label{
        display: none;
    }
    .downloadM .el-checkbox__inner{
        border-radius: 50%;
    }
</style>



// WEBPACK FOOTER //
// src/views/DownLoad.vue